/** 官员仪表板、规划栏目导航、无权访问页面及管理员活动视图（计划 F3）。 */
export default {
  dashboard: {
    title: '规划仪表板',
    subtitle: '提交、检查和审批一览。',
    nav: {
      label: '规划栏目',
      dashboard: '仪表板',
      submissions: '提交',
      mySubmissions: '我的提交',
      registrations: '注册申请',
      activity: '活动',
      settings: '设置',
    },
    noAccessTitle: '无权访问规划模块',
    noAccessBody: '您的账户没有规划角色。请管理员将您加入审核人或批准人组，或批准您的申请人注册。',
    noAccessHome: '返回首页',
    quickActions: '快捷操作',
    newSubmission: '新建提交',
    openStaging: '打开 Peta Staging（暂存地图）',
    openApproved: '打开 Peta Diluluskan（已批准地图）',
    mapsMissing: '保存 设置 → 规划 后，规划地图才会出现。',
    cards: {
      all: '全部提交',
      awaiting: '待审核',
      approved: '已批准',
      returned: '已退回',
      failed: '检查未通过',
      withdrawn: '已撤回',
      committee: '委员会审议中',
      refused: '已拒绝',
      in_force: '有效许可',
    },
    conversion: '每个提交的最新检查',
    conversionInProgress: '进行中',
    conversionPassed: '通过',
    conversionFailed: '未通过',
    conversionErrored: '无法运行',
    successRate: '成功率',
    successRateHint: '通过 ÷（通过 + 未通过）。无法运行的检查不计入。',
    successRateNone: '尚无已完成的检查',
    storage: '已用存储',
    storageHint: '图纸和派生文件；多个版本共用的文件只计一次。',
    byStage: '按阶段',
    crsUsage: '坐标系',
    crsUnknown: 'EPSG {{srid}}（不在规则包中）',
    none: '暂无。',
    recent: '最近的提交',
    recentEmpty: '暂无提交。',
    viewAll: '查看全部提交',
  },
  activity: {
    title: '规划活动',
    subtitle: '规划模块中谁做了什么，最新的在前。时间、IP 地址和浏览器在有记录时显示。',
    notPermitted: '只有租户管理员可以查看规划活动。',
    filterLabel: '操作',
    allActions: '全部操作',
    columns: {
      time: '时间',
      action: '操作',
      actor: '执行人',
      target: '对象',
      ip: 'IP 地址',
      userAgent: '浏览器（用户代理）',
    },
    system: '系统',
    empty: '尚未记录任何规划活动。',
    loadMore: '加载更多',
    loadingMore: '正在加载…',
    targets: {
      planning_case: '提交',
      planning_document: '文件',
      planning_registration: '注册申请',
      planning_settings: '设置',
      planning_import: '案件包导入',
      planning_trusted_system: '受信任系统',
      planning_register_export: '县区登记册导出',
      planning_letter: '决定函',
      user: '人员',
    },
    actions: {
      case_created: '已创建提交',
      case_updated: '已编辑提交',
      case_submitted: '已提交',
      case_resubmitted: '已重新提交',
      case_check_retried: '已重试检查',
      case_approved: '已批准',
      case_returned: '已退回',
      case_withdrawn: '已撤回',
      case_deleted: '已删除',
      document_uploaded: '已上传图纸',
      document_downloaded: '已下载文件',
      register_retried: '已重试地图更新',
      registration_approved: '已批准注册',
      registration_rejected: '已拒绝注册',
      registration_password_issued: '已发放临时密码',
      settings_updated: '已更新设置',
      chain_broken: '历史记录验证失败',
      calendar_updated: '工作日日历已更新',
      procedure_updated: '流程调整已保存',
      case_exported: '已请求导出案件包',
      case_export_downloaded: '已下载案件包',
      case_authority_recalled: '已从其他系统收回案件',
      seal_key_rotated: '已更换案件包签名密钥',
      import_validated: '已检查案件包',
      case_imported: '已导入案件包',
      case_external_id_linked: '已关联外部编号',
      trusted_system_updated: '已保存受信任系统',
      trusted_system_deleted: '已删除受信任系统',
      case_transition: '已执行流程步骤',
      case_referral_requested: '已请求技术意见',
      case_referral_answered: '已收到技术意见',
      case_referral_withdrawn: '已撤回意见请求',
      case_linked: '已关联提交',
      case_unlinked: '已移除提交关联',
      case_assigned: '已分配提交',
      case_intake_tool: '已使用图纸检查工具',
      letter_prepared: '已准备决定函',
      letter_issued: '已签发决定函',
      letter_discarded: '已弃用决定函草稿',
      letter_shared: '已向申请人共享决定函',
      letter_unshared: '已对申请人隐藏决定函',
      letter_email_released: '已发送被搁置的决定邮件',
      letter_signed: '已验证已签署的决定函',
      signing_certificate_requested: '已申请签名证书',
      signing_certificate_ready: '签名证书已就绪',
      signing_certificate_status_changed: '签名证书已启用或停用',
      signing_certificate_approved: '个人签名证书已批准',
      signing_certificate_deleted: '签名证书已删除',
      letter_sign_requested: '已请求在 gisify 中签署决定函',
      register_exported: '已请求县区登记册导出',
      register_export_downloaded: '已下载县区登记册导出',
      case_external_id_unlinked: '已取消关联外部编号',
      case_mirror_marked: '已更新 OSC 同步清单',
      notification_test_sent: '已发送测试邮件',
      notification_resent: '邮件已重新排队',
      notification_preferences_updated: '已更改电子邮件偏好',
    },
  },
} as const
